import { EntityNameModal } from '@/pages/admin/shared/entity-management/EntityNameModal';

type CreateCategoryModalProps = {
	isOpen: boolean;
	onClose: () => void;
	onCreate: (payload: { name: string; description?: string }) => void;
};

export const CreateCategoryModal = ({
	isOpen,
	onClose,
	onCreate,
}: CreateCategoryModalProps) => {
	return (
		<EntityNameModal
			isOpen={isOpen}
			onClose={onClose}
			title="Criar categoria"
			description="Insira o nome da nova categoria para organizar o formulário."
			label="NOME DA CATEGORIA"
			placeholder="Ex: Bem-estar"
			submitText="Criar categoria"
			inputId="form-modal-cat-name"
			descriptionFieldId="form-modal-cat-description"
			descriptionFieldLabel="DESCRIÇÃO (OPCIONAL)"
			descriptionFieldPlaceholder="Ex: Perguntas sobre bem-estar e qualidade de vida no trabalho."
			onSubmitValues={onCreate}
		/>
	);
};
